export default {
	name: 'filter-tabs'
};
